<template>
  <div class="Works">
    <div class="sliderWrapper" ref="sliderWrapper">
      <main-title v-for="(project, index) in projects" :id="index" :key="index" :worktype="project.type" @click.native="openProject(index)">
        {{project.name}}
      </main-title>
    </div>
    <div ref="single" class="single">
      <button class="closeProject" @click="closeProject">
        <svg width="40" height="40">
          <g stroke="white" fill-rule="evenodd" stroke-linecap="square">
            <path stroke="white" d="M.5.5l39 37M39.5.5l-38 37"/>
          </g>
        </svg>
      </button>
      <single-project :title="currentProject.name" :videoid="currentProject.videoid"
      :has-video="currentProject.hasVideo"
      :active="vimeoActive"
      :image-sample="currentProject.imageSample"
      :description="currentProject.description"
      :worktype="currentProject.type"
      >
      </single-project>
    </div>
  </div>
</template>
<script>
import {TweenMax, Power3} from 'gsap'
import WorldEngine from '@/components/WorldEngine'
import MainTitle from '@/components/MainTitle'
import SingleProject from '@/components/SingleProject'
export default {
  name: 'Works',
  components: {
    WorldEngine,
    MainTitle,
    SingleProject
  },
  data() {
    return {
      projects: [
        { name: `Vue Design System`, type: 'library', hasVideo: false, videoid: '250701341', imageSample: 'vuedesignsystem.gif', description: `Vuejs UI library based on global BBVA design system, including taxonomy definition, UI development, interaction development and abstract components such as transitions.`},
        { name: 'Audits Sketch Plugin', type: 'sketch plugin', hasVideo: false, videoid: '250701341', imageSample: 'sketchplugin.png', description: `Sketch plugin to measure different KPI in the current sketch file. This plugin was totally customized for BBVA global design system libaries. In other hand it gives you: reused percentage of design system components, amount unique components, amount of no tracked library symbols, top ten most used components grouped by family and many others.`},
        { name: 'Beat Machine', type: 'website', hasVideo: true, videoid: '250701341', description: `A heart rate detector using the webcam of desktop browser, with pure javascript and webgl canvas. On this project I had to make a DSP( digital signal processor) class and  a Math library to acomplish the brief. In the other side, I proposed a math formula for the movement in the main shader`},
        { name: 'Remixxes', type: 'website', hasVideo: true, videoid: '328025484', description: `A guitar hero like THREE JS game to play in browser, optimized for mobile. Beacause it has many drum beats, basslines and melodies to mix, the main task was to sync notes with sounds in order to recreate every possible song and achieve a quiet natural interaction.`},
        { name: 'Cocula', type: 'website', hasVideo: false, videoid: '250701341', imageSample: 'cocula.png', description:`Interactive map of small town in Mexico called "Cocula", we want transform this community to the digital age making their lifes cashless. This site teach the people how to use credit and debit cards.`},
      ],
      currentProject: null,
      vimeoActive: false
    };
  },
  created() {
    this.currentProject = this.projects[0]
  },
  destroy() {
    this.closeProject()
  },
  mounted() {
    const { single } = this.$refs
    TweenMax.set(single,{
      autoAlpha: 0,
      height: '0vh'
    })
  },
  methods: {
    openProject(index) {
      this.vimeoActive = true;
      this.currentProject = this.projects[index]
      const { single } = this.$refs
      const kids = this.$refs.sliderWrapper.children
      TweenMax.staggerTo(kids, 0.3,{
        y: -300,
        autoAlpha: 0,
      }, 0.051)

      TweenMax.fromTo(single, 0.3,{
        y: 500,
        autoAlpha: 0,
        height: '0vh'
      }, {
        y: 0,
        autoAlpha: 1,
        height: '100vh',
      })
    },
    closeProject() {
      this.vimeoActive = false;
      const { single } = this.$refs
      TweenMax.fromTo(single, 0.3,{
        y: 0,
        autoAlpha: 1,
        height: '100vh',
      }, {
        y: 500,
        autoAlpha: 0,
        height: '0vh'
      })
      const kids = this.$refs.sliderWrapper.children
      TweenMax.staggerTo(kids, 0.3,{
        y: 0,
        autoAlpha: 1,
      }, 0.051)
    },
  },
};
</script>
<style src="../styles/views/Works.styl" lang="stylus"></style>
